import { render, staticRenderFns } from "./DTHeaderComponent.vue?vue&type=template&id=8dd789c2&scoped=true&"
import script from "./DTHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./DTHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd789c2",
  null
  
)

export default component.exports